interface ReadingProgressBarProps {
    percent: number;
}

export default function ReadingProgressBar({ percent }: ReadingProgressBarProps) {
    const clamped = Math.min(100, Math.max(0, percent));

    return (
        <div
            className="fixed inset-x-0 top-16 z-30 h-1 bg-lightGrey/60 dark:bg-gray-700/60"
            role="progressbar"
            aria-valuenow={Math.round(clamped)}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label="Reading progress"
        >
            <div
                className="h-full w-full origin-left bg-darkBlue dark:bg-lightBlue"
                style={{ transform: `scaleX(${clamped / 100})` }}
            />
        </div>
    );
}
